import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import config from '../config';
import { useAuth } from '../context/AuthContext';

const vouchersList = [
    {
        id: 'fazaa',
        name: 'Fazaa',
        image: '/assets/images/vouchers/fazaa.png',
        url: 'https://www.fazaa.ae/'
    },
    {
        id: 'esaad',
        name: 'Esaad',
        image: '/assets/images/vouchers/esaad.png',
        url: 'https://esaad.dubaipolice.gov.ae/home'
    },
    {
        id: 'entertainer',
        name: 'The ENTERTAINER',
        image: '/assets/images/vouchers/theentertainerme.png',
        url: 'https://www.theentertainerme.com/'
    }
];

const VenueVouchersManager = ({ venueId, initialVouchers, onUpdated }) => {
    const { auth } = useAuth();
    const [selectedVouchers, setSelectedVouchers] = useState([]);
    const [savingVouchers, setSavingVouchers] = useState(false);

    useEffect(() => {
        if (Array.isArray(initialVouchers)) {
            setSelectedVouchers(initialVouchers);
        } else if (initialVouchers) {
            try {
                const parsed = typeof initialVouchers === 'string'
                    ? JSON.parse(initialVouchers)
                    : initialVouchers;
                setSelectedVouchers(Array.isArray(parsed) ? parsed : []);
            } catch (e) {
                setSelectedVouchers([]);
            }
        }
    }, [initialVouchers]);

    const toggleVoucher = (id) => {
        setSelectedVouchers((prev) =>
            prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
        );
    };

    const handleSaveVouchers = useCallback(async () => {
        if (!venueId) return;
        setSavingVouchers(true);
        try {
            const response = await auth.fetch(`${config.API_BASE_URL}/api/v2/venues/${venueId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ vouchers: selectedVouchers })
            });

            let data = {};
            try {
                data = await response.json();
            } catch (e) {
                data = {};
            }

            if (response.ok) {
                toast.success('Vouchers updated successfully');
                if (onUpdated) onUpdated();
            } else {
                toast.error(data.message || 'Failed to update vouchers');
            }
        } catch (error) {
            console.error('Error updating vouchers:', error);
            toast.error('Failed to update vouchers');
        } finally {
            setSavingVouchers(false);
        }
    }, [auth, venueId, selectedVouchers, onUpdated]);

    return (
        <div className="card shadow-none border radius-12">
            <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 py-16 px-24 border-bottom bg-white radius-top-12">
                <div>
                    <h6 className="mb-0 fw-bold text-dark">Partner Vouchers & Deals</h6>
                    <span className="text-secondary-light text-xs">
                        Select applicable corporate and government loyalty discount programs for this venue
                    </span>
                </div>
                <div className="d-flex align-items-center gap-12">
                    <button
                        type="button"
                        className="hs-btn-primary hs-btn-sm"
                        onClick={handleSaveVouchers}
                        disabled={savingVouchers}
                    >
                        {savingVouchers ? 'Saving...' : 'Save Selection'}
                    </button>
                </div>
            </div>
            <div className="card-body p-24">
                <div className="row g-24">
                    {vouchersList.map((voucher) => (
                        <div className="col-md-4" key={voucher.id}>
                            <label
                                className={`d-block border radius-12 p-16 h-100 cursor-pointer transition-all ${
                                    selectedVouchers.includes(voucher.id)
                                        ? 'border-primary-600 bg-primary-50 shadow-sm'
                                        : 'border-neutral-200 bg-white'
                                }`}
                                title={voucher.url}
                            >
                                <div className="d-flex justify-content-between align-items-start mb-12">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={selectedVouchers.includes(voucher.id)}
                                            onChange={() => toggleVoucher(voucher.id)}
                                        />
                                        <span className="ms-8 fw-semibold text-dark">{voucher.name}</span>
                                    </div>
                                </div>
                                <div className="text-center mb-12 py-2">
                                    <img
                                        src={voucher.image}
                                        alt={voucher.name}
                                        className="img-fluid"
                                        style={{ maxHeight: '70px', objectFit: 'contain' }}
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                </div>
                                <div className="text-center">
                                    <a
                                        href={voucher.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary-600 text-xs text-decoration-none fw-medium"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        Visit {voucher.name} Portal &rarr;
                                    </a>
                                </div>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VenueVouchersManager;
